import React, { useEffect, useState } from 'react';
import api from '../Api';

export default function LaporanJenisPengaduan() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);

  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');

  // ================= FETCH DATA =================
  const fetchSummary = async (customParams = {}) => {
    try {
      setLoading(true);

      const res = await api.get('/report/summary-json', {
        params: customParams,
      });

      setData(res.data);
    } catch (err) {
      console.error('Gagal fetch jenis pengaduan:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSummary();
  }, []);

  // ================= FILTER =================
  const handleFilter = () => {
    if (from && to && from > to) {
      alert('Tanggal From tidak boleh lebih besar dari To');
      return;
    }

    const params = {};

    if (from && to) {
      params.from = from;
      params.to = to;
    }

    fetchSummary(params);
  };

  // ================= RESET =================
  const handleReset = () => {
    setFrom('');
    setTo('');
    fetchSummary();
  };

  // ================= EXPORT EXCEL =================
  const handleExportExcel = async () => {
    try {
      if (from && to && from > to) {
        alert('Tanggal From tidak boleh lebih besar dari To');
        return;
      }

      setExportLoading(true);

      const params = {};

      if (from && to) {
        params.from = from;
        params.to = to;
      }

      const response = await api.get('/report/summary', {
        params,
        responseType: 'blob',
      });

      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);

      // Nama file otomatis sesuai filter
      const fileName = from && to ? `laporan_jenis_pengaduan_${from}_sd_${to}.xlsx` : 'laporan_jenis_pengaduan.xlsx';

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);

      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Export gagal', err);
      alert('Gagal export excel');
    } finally {
      setExportLoading(false);
    }
  };

  if (loading) return <p className="text-center mt-4">Loading...</p>;
  if (!data) return null;

  // ================= FUNCTION RENDER PER WILAYAH =================
  const renderPerWilayah = (title, source) => {
    const wilayahList = Array.from(new Set(Object.values(source).flatMap((kat) => Object.keys(kat))));

    return (
      <div className="mb-5">
        <h4 className="fw-bold text-uppercase mb-4 border-bottom pb-2">{title}</h4>

        {wilayahList.map((wilayah) => {
          let totalProblem = 0;
          let totalSolved = 0;
          let totalProgress = 0;

          return (
            <div key={wilayah} className="mb-4 shadow-sm p-3 rounded bg-white">
              <h6 className="fw-bold text-primary mb-3">{wilayah}</h6>

              <div className="table-responsive">
                <table className="table table-bordered table-sm text-center align-middle">
                  <thead className="table-light">
                    <tr>
                      <th>No</th>
                      <th className="text-start">Kategori Pengaduan</th>
                      <th>Problem</th>
                      <th>Solved</th>
                      <th>On Progress</th>
                    </tr>
                  </thead>

                  <tbody>
                    {Object.entries(source).map(([kategori, wilayahData], i) => {
                      const d = wilayahData[wilayah];
                      if (!d) return null;

                      totalProblem += d.problem;
                      totalSolved += d.solved;
                      totalProgress += d.on_progress;

                      return (
                        <tr key={kategori}>
                          <td>{i + 1}</td>
                          <td className="text-start">{kategori}</td>
                          <td>{d.problem}</td>
                          <td className="text-success fw-bold">{d.solved}</td>
                          <td className="text-warning fw-bold">{d.on_progress}</td>
                        </tr>
                      );
                    })}

                    <tr className="table-secondary fw-bold">
                      <td colSpan={2}>TOTAL</td>
                      <td>{totalProblem}</td>
                      <td className="text-success">{totalSolved}</td>
                      <td className="text-warning">{totalProgress}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div className="container py-4">
      <h3 className="fw-bold mb-3">Laporan Jenis Pengaduan</h3>

      {/* ================= FILTER ================= */}
      <div className="row g-2 mb-4">
        <div className="col-md-2">
          <label className="form-label">From</label>
          <input type="date" className="form-control" value={from} onChange={(e) => setFrom(e.target.value)} />
        </div>

        <div className="col-md-2">
          <label className="form-label">To</label>
          <input type="date" className="form-control" value={to} onChange={(e) => setTo(e.target.value)} />
        </div>

        <div className="col-md-8 d-flex align-items-end gap-2">
          <button className="btn btn-primary" onClick={handleFilter} disabled={loading}>
            {loading ? 'Loading...' : 'Filter'}
          </button>

          <button className="btn btn-secondary" onClick={handleReset} disabled={loading}>
            Reset
          </button>

          <button className="btn btn-success" onClick={handleExportExcel} disabled={exportLoading}>
            {exportLoading ? 'Generating...' : 'Generate Excel'}
          </button>
        </div>
      </div>

      {/* ================= TECHNICAL ================= */}
      {renderPerWilayah('Technical', data.technical)}

      {/* ================= ADMINISTRATIF ================= */}
      {renderPerWilayah('Administratif', data.administratif)}

      {/* ================= ASAL PENGADUAN ================= */}
      <div className="mb-5">
        <h4 className="fw-bold text-uppercase mb-4 border-bottom pb-2">Asal Pengaduan</h4>

        <div className="shadow-sm p-3 rounded bg-white w-50">
          <table className="table table-bordered text-center">
            <thead className="table-light">
              <tr>
                <th>Asal</th>
                <th>Jumlah</th>
              </tr>
            </thead>
            <tbody>
              {data.asal_pengaduan.map((a, i) => (
                <tr key={i}>
                  <td className="text-start text-capitalize">{a.asal}</td>
                  <td className="fw-bold">{a.jumlah}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* ================= KONSOLIDASI KATEGORI ================= */}
      <div className="mb-5">
        <h4 className="fw-bold text-uppercase mb-4 border-bottom pb-2">Konsolidasi Kategori</h4>

        <div className="shadow-sm p-3 rounded bg-white">
          <table className="table table-bordered text-center">
            <thead className="table-light">
              <tr>
                <th>Kategori</th>
                <th>Problem</th>
                <th>Solved</th>
                <th>On Progress</th>
              </tr>
            </thead>
            <tbody>
              {data.konsolidasi_kategori.map((k, i) => (
                <tr key={i}>
                  <td className="text-start">{k.kategori}</td>
                  <td>{k.problem}</td>
                  <td className="text-success fw-bold">{k.solved}</td>
                  <td className="text-warning fw-bold">{k.on_progress}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* ================= KONSOLIDASI WILAYAH ================= */}
      <div className="mb-5">
        <h4 className="fw-bold text-uppercase mb-4 border-bottom pb-2">Konsolidasi Wilayah</h4>

        <div className="shadow-sm p-3 rounded bg-white">
          <table className="table table-bordered text-center">
            <thead className="table-light">
              <tr>
                <th>Wilayah</th>
                <th>Problem</th>
                <th>Solved</th>
                <th>On Progress</th>
                <th>Rasio (%)</th>
              </tr>
            </thead>
            <tbody>
              {data.konsolidasi_wilayah.map((w, i) => (
                <tr key={i}>
                  <td className="text-start">{w.wilayah}</td>
                  <td>{w.problem}</td>
                  <td className="text-success fw-bold">{w.solved}</td>
                  <td className="text-warning fw-bold">{w.on_progress}</td>
                  <td className="fw-bold">{w.ratio}%</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* ================= GRAND TOTAL ================= */}
      <div className="mb-5">
        <h4 className="fw-bold text-uppercase mb-4 border-bottom pb-2">Grand Total</h4>

        <div className="shadow-sm p-3 rounded bg-white w-50">
          <table className="table table-bordered">
            <tbody>
              <tr>
                <td>Total Problem</td>
                <td className="text-end fw-bold">{data.grand_total.total_problem}</td>
              </tr>
              <tr>
                <td>Total Solved</td>
                <td className="text-end text-success fw-bold">{data.grand_total.total_solved}</td>
              </tr>
              <tr>
                <td>Total On Progress</td>
                <td className="text-end text-warning fw-bold">{data.grand_total.total_on_progress}</td>
              </tr>
              <tr className="table-secondary fw-bold">
                <td>Rasio Penyelesaian</td>
                <td className="text-end">{data.grand_total.ratio}%</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
